import { render } from "./ContentsBundleThumbnails.vue?vue&type=template&id=88a99606&scoped=true&ts=true"
import script from "./ContentsBundleThumbnails.vue?vue&type=script&lang=ts"
export * from "./ContentsBundleThumbnails.vue?vue&type=script&lang=ts"

import "./ContentsBundleThumbnails.vue?vue&type=style&index=0&id=88a99606&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88a99606"]])

export default __exports__